import React, { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';

import api from '../actions/api';
import AsyncGet from '../components/Materials/AsyncGet';
import { useDispatch, useSelector } from 'react-redux';
import { resetStore } from '../actions/storage';
import { get } from 'lodash';
import { getCurrentUnixTimeStamp } from '../helpers/date';

const IdleFunc = ({ loadFromAPI }) => {
    const [activeTime, setActiveTime] = useState(getCurrentUnixTimeStamp());
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const onIdle = () => {
        logoutDueToInactivity();
    }

    const onActive = () => {
        checkIfCansetActiveTime()
    }

    const onAction = () => {
        checkIfCansetActiveTime()
    }

    useIdleTimer({
        onIdle,
        onActive,
        onAction,
        timeout: 1000 * 60 * 60,
        crossTab: true,
        debounce: 250,
        syncTimers: 200,
        leaderElection: true,
    });

    const checkIfCansetActiveTime = (e) => {
        if ((getCurrentUnixTimeStamp() - activeTime) > 30) {
            setActiveTime(getCurrentUnixTimeStamp());
            loadFromAPI();
        }
    }

    const logoutDueToInactivity = () => {
        api.get('account/logout').then((res) => {
            if (res.status === 200) {
                dispatch(resetStore())
                navigate("/");
            }
        });
    }

    return (<></>)
}

const IdleTimer = () => {
    const { data } = useSelector(state => get(state, 'storage'));
    if (!get(data, 'id')) {
        return null;
    }
    return (
        <AsyncGet
            url="account/setlastactivity"
            loadOnMount={true}
            permissionText={false}
            render={({ loadFromAPI }) => {
                return (
                    <IdleFunc loadFromAPI={loadFromAPI} />
                )
            }}
        />
    )
}

export default IdleTimer;